import React from "react"
import { Kbd, type KbdProps } from "../kbd"
import { cn } from "../utils"

export type CommandKbdProps = KbdProps

/**
 * A `Kbd` that uppercases its key, since palette chords are authored lowercase
 * (`"g s"`) but read as `G` `S`. Used on its own (e.g. an `↵` in
 * `Command.Hint`) or grouped by `Command.Shortcut` for a chord.
 */
export function CommandKbd({ className, ...props }: CommandKbdProps) {
  return <Kbd className={cn("uppercase", className)} {...props} />
}

CommandKbd.displayName = "Command.Kbd"
